import { Component, HostListener, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { Categoria } from 'src/app/interfaces/categoria';
import { Ciudad } from 'src/app/interfaces/ciudad';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CategoriasService } from 'src/app/services/categorias.service';
import { CiudadesService } from 'src/app/services/ciudades.service';
import { CommonService } from 'src/app/services/common.service';
import { LocationService } from 'src/app/services/location.service';
import { ShoppingCartService } from 'src/app/services/shopping-cart.service';
import { StaticService } from 'src/app/services/static.service';
import { FiltersComponent } from '../filters/filters.component';
import { MainMenuComponent } from '../main-menu/main-menu.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  // Header Fixed
  isFixed: boolean = false;
  @ViewChild("nav") navElement: any;
  @ViewChild("imgHeader") imgElement: any;
  isHomeComponent: boolean = false;

  // Search
  searchText: string = '';
  @ViewChild('search') search: any;
  // One label for every state: the city already reads in the field beside it
  placeholder: string = 'Buscar planes';
  searching!: string;

  // Select
  ciudades: Ciudad[];
  categorias: any;

  cityForm: FormControl = new FormControl('');

  /**
   * Character count for the city input, so the field hugs its own text
   * instead of holding Material's default 180px width.
   */
  get citySize(): number {
    const value: any = this.cityForm.value;
    return ((value && value.name) || 'Todas las ciudades').length + 1;
  }
  city!: any;
  category!: any;
  profile!: any;
  isAdmin: boolean = false;
  adminCitylok: boolean = false;
  userMode: 'user' | 'organizer' = 'organizer';
  isProfileRoute: boolean = false;
  localizacion!: any;

  isHomeInit: boolean = false;
  urlImages: string = AppSettings.MEDIA_URI + '/users_images';
  subscriber: any;
  // numTicketsCart!: Observable<any>;
  numTicketsCart!: any;

  constructor(private router: Router, private categoriasService: CategoriasService, private ciudadesService: CiudadesService, private commonService: CommonService,
    private locationService: LocationService, private dialog: MatDialog, private auth: AuthenticationService, private staticService: StaticService, private renderer: Renderer2,
    private shoppingCartService: ShoppingCartService) {
    this.categoriasService.getCategoriesWithEvents().subscribe({
      next: (val) => {
        this.categorias = val.data.data;
      }
    });
    this.auth.userMode$.subscribe(mode => { this.userMode = mode; });
    this.auth.profileStorage.subscribe({
      next: (res) => {
        this.profile = res;
        this.isAdmin = this.profile?.roles?.filter((role: any) => role.name == 'admin' || role.name == 'superadmin').length > 0;
        this.adminCitylok = this.profile?.citylok;
        if (this.profile) {
          this.shoppingCartService.updateCartObservable.subscribe({
            next: (res) => {
              // this.numTicketsCart = this.shoppingCartService.getCartUser().pipe(map(value => {
              //   return value.cart.tickets.length;
              // }));
              // this.shoppingCartService.getCartUser().subscribe({
              //   next: (value) => {
              //     this.numTicketsCart = value.cart.tickets.length;
              //   }
              // });
            }
          });
        } else {
          this.subscriber?.unsubscribe();
        }
      }
    })
  }

  ngOnInit(): void {
    if (location.href != '/') {
      this.isHomeInit = false;
      this.isHomeComponent = false;

      this.cityForm.valueChanges.subscribe(value => {
        this.changeCity(value);
      });
    }
    this.localizacion = localStorage.getItem('localizacion');
    if (this.localizacion != null) {
      let loc = JSON.parse(this.localizacion);
      this.commonService.setLocation(loc.latitud, loc.longitud);
    }
  }

  ngAfterViewInit() {
    this.isProfileRoute = this.router.url.startsWith('/profile');
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        this.isProfileRoute = event.url.startsWith('/profile');
        if (!event.url.startsWith('/category')) {
          this.category = null;
          this.commonService.setCategory(null)
        } else {
          this.commonService.categoryStage.subscribe(cat => {
            this.category = cat;
          });
        }
        if (event.url == '/' || event.url.startsWith('/inicio') || event.url.startsWith('/about')) {
          this.isHomeComponent = true;
          this.onScroll();
        } else {
          this.isHomeComponent = false;
          this.headerWhite();
        }
      }
    });
    this.ciudadesService.getCitiesWithEvents().subscribe({
      next: (val) => {
        this.ciudades = val.data.data;
      },
      complete: () => {
        this.getCityStorage();
      }
    });
    let location = localStorage.getItem('localizacion');
    if (location) {
      let loc = JSON.parse(location);
    }
  }

  getCityStorage() {
    this.commonService.cityStorage.subscribe(city => {
      if (city) {
        if (this.city == city) {
          return;
        }
        this.ciudadesService.getCiudadbyId(city).subscribe(object => {
          let existCity = this.ciudades.find((c: any) => {
            return c.city.id == city
          });
          if (!existCity) {
            this.city = null;
            this.cityForm.setValue(null);
            this.placeholder = 'Buscar planes';
            return;
          }
          this.cityForm.setValue(object.data);
          this.placeholder = 'Buscar planes';
        });
      } else {
        this.city = null;
        this.cityForm.setValue(null);
        this.placeholder = 'Buscar planes';
      }
      let existCity = this.ciudades.find((c: any) => {
        return c.city.id == city
      });
      this.city = existCity ? city : null;
    });
    let storageCity = sessionStorage.getItem('city');
    if (storageCity) {
      let existCity = this.ciudades.find((c: any) => {
        return c.city.id == storageCity
      });
      if (!existCity) {
        this.city = null;
        this.commonService.setCity(null);
        localStorage.removeItem('city');
        this.getPermission();
        return;
      }
      this.commonService.setCity(+storageCity);
    }
    if (!storageCity) {
      // Si no hay ciudad en almacenamiento, dejamos el filtro en "Todas las ciudades"
      // y no forzamos una selección automática por geolocalización.
    }
  }

  getPermission() {
    navigator.permissions.query({ name: 'geolocation' }).then((permissionStatus) => {
      this.locationService.permissionLocaton.next(permissionStatus.state);
      if (permissionStatus.state == 'granted') { this.getLocation() }
      permissionStatus.addEventListener("change", () => {
        this.getGeoLocation(permissionStatus.state);
      });
    });
  }

  getGeoLocation(permission) {
    this.locationService.permision.subscribe(per => {
      if (per == 'granted') {
        this.getLocation();
      }
    })
  }

  async getLocation() {
  try {
    const location = await this.locationService.getPosition();
    if (location) {
      if (location.lat != this.localizacion?.latitud || location.lng != this.localizacion?.longitud) {
        this.commonService.setLocation(location.lat, location.lng);
      }
      // Ya no seleccionamos automáticamente una ciudad en base a la geolocalización.
    }
  } catch (error) {
    // Esto silencia el error en consola y permite manejar el fallo
    console.warn("No se pudo obtener la ubicación: ", error);
    // Opcional: establecer una ciudad por defecto si falla el GPS
  }
}

  getCityPosition(location: any) {
    this.locationService.getCityByPosition(location).subscribe(data => {
      let name = data.city || data.locality;
      // Find city on ciudades
      const cityBD: any = this.ciudades?.find((value: any) => value.city.name.toLowerCase() == name.toLowerCase());
      if (cityBD) {
        this.commonService.setCity(cityBD.city.id);
      }
    });
  }


  @HostListener('window:scroll', [])
  onScroll(): void {
    if (window.scrollY < 545) {
      this.isFixed = false;
    } else {
      this.isFixed = true;
    }
    if (window.scrollY < 550 && this.isHomeComponent) {
      this.imgElement.nativeElement.style['content'] = 'url(assets/img/citylok_white.svg)';
      this.navElement.nativeElement.classList.add('headerTransparent');
      this.navElement.nativeElement.classList.remove('headerWhite');
      this.markHeaderTheme(false);

    } else {
      this.headerWhite();
    }
  }

  headerWhite() {
    this.isFixed = true;
    this.imgElement.nativeElement.style['content'] = 'url(assets/img/citylok_horizontal.svg)';
    this.navElement.nativeElement.classList.add('headerWhite');
    this.navElement.nativeElement.classList.remove('headerTransparent');
    this.markHeaderTheme(true);
  }

  /**
   * The city and category panels render in a CDK overlay hanging off <body>,
   * so they cannot see .headerWhite on the nav. Mirroring the state onto the
   * body is what lets them follow the header: plum over the hero, white
   * everywhere else.
   */
  private markHeaderTheme(isWhite: boolean): void {
    const method = isWhite ? 'addClass' : 'removeClass';
    this.renderer[method](document.body, 'header-is-white');
  }

  searchEvents(searching: string) {
    this.searching = searching;
    this.searchText = '';
    if (searching) {
      this.router.navigate(['/results'], { queryParams: { search: searching } })
    } else {
      this.router.navigate(['/']);
    }
  }

  openInNewTab(event: MouseEvent) {
    event.preventDefault();
    window.open('/', '_blank');
  }

  openFilters() {
    let position: any = { top: '0px', right: '0px' };
    let animation: any = "animation-right-dialog";
    if (window.innerWidth < 1200) {
      position = { top: '0px', left: '0px' };
      animation = "animation-left-dialog";
    }
    const dialogRef = this.dialog.open(FiltersComponent, {
      width: "570px",
      panelClass: ['panel-dialog', 'panel-dialog-left', animation],
      position: position
    });
  }

  async changeCity(city: any) {
    if (city?.id) {
      if (this.city != city?.id) {
        this.commonService.setCity(city.id);
      }
    }
    else if (this.city) {
      this.commonService.setCity(null);
      this.cityForm.setValue(null);
      this.city = null;
    }
    if (city) {
      if (!city.id) {
        await this.ciudadesService.getCitiesWithEvents().subscribe(
          res => {
            this.ciudades = res.data.data;
          }
        )
      }
    } else {
      await this.ciudadesService.getCitiesWithEvents().subscribe(
        res => {
          this.ciudades = res.data.data;
        }
      )
    }
  }

  displayCity(city: any): string {
    return city ? city.name : '';
  }

  goToFavorites() {
    if (!this.profile) {
      this.staticService.setFrom('favoritos');
    }
    this.router.navigate(['/user/favorites']);
  }

  openMenu() {
    const dialogRef = this.dialog.open(MainMenuComponent, {
      width: '440px',
      panelClass: ['main-menu-dialog', 'animate_slideRight'],
      position: {
        top: '0px',
        right: '0px'
      }
    })
  }

  switchMode(mode: 'user' | 'organizer') {
    if (this.userMode === mode) return;
    this.auth.setUserMode(mode);
    this.router.navigate([mode === 'user' ? '/profile' : '/panel-control/events']);
  }

  goProfile() {
    if (this.isAdmin && this.userMode === 'organizer') {
      const url = this.adminCitylok ? '/panel-control/list-business' : '/panel-control/config/info-profile';
      this.router.navigate([url]);
    } else {
      this.router.navigate(['/profile']);
    }
  }

}
